import onGhostTextAccepted from '../actions/onGhostTextAccepted';
import getSuggestionAtIndex from '../selectors/getSuggestionAtIndex';
import getScenarioStore from '../store/getScenarioStore';
import getSubstrateSearchScenarioBySearchScenarioId from '../utils/getSubstrateSearchScenarioBySearchScenarioId';
import { logUsage } from 'owa-analytics';
import { lazyLogSearchBoxStateChanged } from 'owa-search-service';
import { orchestrator } from 'satcheljs';

/**
 * This function runs when the searchbox text was changed because of the user
 * accepting the suggested ghost text.
 */
orchestrator(onGhostTextAccepted, actionMessage => {
    const { scenarioId } = actionMessage;

    // Get suggestion that is being ghosted.
    const suggestion = getSuggestionAtIndex(0 /* index */, scenarioId);

    // Since getSuggestionAtIndex can return null, do a null check for safety.
    if (!suggestion) {
        return;
    }

    /**
     * Log 3S instrumentation event that search box text is changing because of
     * ghost text.
     */
    lazyLogSearchBoxStateChanged.importAndExecute(
        new Date() /* currentTime */,
        'ghost' /* reason */,
        suggestion.ReferenceId,
        getScenarioStore(scenarioId).latestTraceId,
        getSubstrateSearchScenarioBySearchScenarioId(scenarioId)
    );

    // Log datapoint.
    logUsage('Search_SuggestionTextAutocompleted', [scenarioId]);
});
